"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _select = _interopRequireDefault(require("../../select"));
var _InputError = _interopRequireDefault(require("../../errors/InputError"));
var _excluded = ["value", "formulaOperators", "formulaChange", "labels", "error"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var StyledOperator = _styledComponents["default"].div.withConfig({
  displayName: "Operator__StyledOperator",
  componentId: "sc-1pd2a7f-0"
})(["", ""], function (props) {
  var typography = props.theme.typography;
  return (0, _styledComponents.css)([".Select-value,.Select-menu-outer{font-size:", ";}"], typography.size.paragraphMedium);
});
StyledOperator.displayName = 'StyledOperator';
var Operator = function Operator(_ref) {
  var value = _ref.value,
    formulaOperators = _ref.formulaOperators,
    formulaChange = _ref.formulaChange,
    labels = _ref.labels,
    error = _ref.error,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(StyledOperator, null, /*#__PURE__*/_react["default"].createElement(_select["default"], _extends({
    value: value,
    onChange: formulaChange,
    required: true,
    options: formulaOperators.map(function (item) {
      return {
        value: item.name,
        label: item.displayName
      };
    }),
    className: "formula-operator ".concat(error ? 'error' : ''),
    backgroundColor: "transparent"
  }, otherProps, {
    searchable: false
  })), error && /*#__PURE__*/_react["default"].createElement(_InputError["default"], {
    message: labels.RULES_BUILDER_OPERATOR_MISSING
  }));
};
Operator.defaultProps = {
  error: false
};
Operator.propTypes = {
  error: _propTypes["default"].bool,
  labels: _propTypes["default"].objectOf(_propTypes["default"].string).isRequired,
  value: _propTypes["default"].string.isRequired,
  formulaOperators: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    displayName: _propTypes["default"].string,
    name: _propTypes["default"].string
  })).isRequired,
  formulaChange: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = Operator;